import { defineStore } from 'pinia';
import { ref } from 'vue';

/** Interval (ms) for periodic backend health check */
export const BACKEND_HEALTH_CHECK_INTERVAL_MS = 30_000;

/**
 * Global network/backend state. API client sets backendUnreachable when
 * a request fails due to network error. Periodic health check also updates this.
 */
export const useNetworkStore = defineStore('network', () => {
  const backendUnreachable = ref(false);
  const backendUnreachableMessage = ref('');

  const setBackendUnreachable = (message: string) => {
    backendUnreachable.value = true;
    backendUnreachableMessage.value = message;
  };

  const clearBackendUnreachable = () => {
    backendUnreachable.value = false;
    backendUnreachableMessage.value = '';
  };

  return {
    backendUnreachable,
    backendUnreachableMessage,
    setBackendUnreachable,
    clearBackendUnreachable,
  };
});
